import { Color, Icon, Text } from '@billy/design-system'
import React, { ReactElement } from 'react'

import * as Styled from './styles'

interface StepProps {
  content: string
  isChecked: boolean
  stepNumber: number
}

export const Step = ({ content, isChecked, stepNumber }: StepProps): ReactElement => {
  return (
    <Styled.StepWrapper>
      <Styled.Number isChecked={isChecked}>
        {isChecked ? (
          <Icon icon="check" color={Color.Green400} />
        ) : (
          <Text colorVariant="secondary" variant="bodyLG">
            {stepNumber}
          </Text>
        )}
      </Styled.Number>
      <Text color={isChecked ? Color.Green400 : Color.Grey500} weight="medium" variant="bodySM">
        {content}
      </Text>
    </Styled.StepWrapper>
  )
}
